export const GET_MAP = 'maps/map/get';
export const GET_SUMMARY = 'maps/summary/get';
export const INSERT_SESSION = 'maps/insertSession/put';